var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadcrumb"},[_c('button',{ref:"focusMe",staticClass:"btn btn-link btn-back",attrs:{"title":"Zurück"},on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":"/assets/icons/left-arrow.png","alt":"Zurück"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }